function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.2477 24.1408C23.2477 24.8334 22.7348 25.3944 22.1016 25.3944H15.2244C14.5912 25.3944 14.0782 24.8334 14.0782 24.1408V20.3803H0.323975V31.662C0.323975 33.6676 1.92864 35.4225 3.76254 35.4225H33.5634C35.3973 35.4225 37.002 33.6676 37.002 31.662V20.3803H23.2477V24.1408ZM33.5634 7.84507H27.8325V4.08451C27.8325 2.07887 26.2278 0.323944 24.3939 0.323944H12.932C11.0981 0.323944 9.49348 2.07887 9.49348 4.08451V7.84507H3.76254C1.92864 7.84507 0.323975 9.6 0.323975 11.6056V17.8732H37.002V11.6056C37.002 9.6 35.3973 7.84507 33.5634 7.84507ZM23.2477 7.84507H14.0782V5.33803H23.2477V7.84507Z",
  fill: "white"
});

function SvgOffice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice);
export default __webpack_public_path__ + "static/media/office.11d90a67c6ab4aa26412b8c3de2fc24f.svg";
export { ForwardRef as ReactComponent };